import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SharedDataService } from '../shared-data.service';
import { CpLoaderService } from '../cp-loader.service';
import { finalize } from 'rxjs/operators';

@Injectable()
export class CpHttpInterceptor implements HttpInterceptor {
  constructor(
    private sharedData: SharedDataService,
    private loaderService: CpLoaderService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    const currentUser = this.sharedData.getCurrentUserToken();
    const userData = this.sharedData.getUserDataFromLS();

    if (currentUser && currentUser.token) {
      const headersObj: Headers = {};
      headersObj.Authorization = `token ${currentUser.token}`;

      if (userData && userData.divisionId) {
        headersObj.division = userData.divisionId;
      }
      if (userData && userData.instrumentId) {
        headersObj.instrument = userData.instrumentId;
      }
      if (userData && userData.roleId) {
        headersObj.role = userData.roleId;
      }

      headersObj.iscadmin = String(userData && userData.isCorporateAdmin ? true : false);

      request = request.clone({
        setHeaders: headersObj
      });
    }

    this.loaderService.show(request.url);
    return next.handle(request).pipe(
      finalize(() => {
        this.loaderService.hide(request.url);
      })
    );
  }
}

/**
 * Type Interface for HTTP Headers.
 */
 interface Headers {
  [key: string]: string;
}
